import get from 'lodash/get';
import NearLocation from '@/components/locator/mixins/near-location';

const GoogleAutoComplete = {
  mixins: [NearLocation],
  created() {
    if (!window.google) {
      window.addEventListener('load', this.initGoogleMaps);
    } else {
      this.initGoogleMaps();
    }
  },
  computed: {
    isAutoLocationSupported() {
      return (this.geoipLocation || !!navigator.geolocation) && this.isGoogleMapsReady;
    },
  },
  watch: {
    textSearchQuery(value) {
      this.getSuggestions(value);
    },
    queryCenter(val) {
      this.$emit('queryCenter', val);
    },
  },
  methods: {
    initGoogleMaps() {
      if (!window.google) {
        console.error('Cannot initialize google maps auto-complete service.');
        return;
      }

      this.autoCompleteService = new window.google.maps.places.AutocompleteService();
      this.placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
      this.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
      this.isGoogleMapsReady = true;
    },
    getSuggestions(value) {
      if (value.length < this.minQueryLength || !this.isGoogleMapsReady) {
        this.placeSuggestions = [];
        return;
      }

      this.autoCompleteService.getPlacePredictions(
        {
          input: value,
          sessionToken: this.sessionToken,
        },
        (predictions, status) => {
          this.placeSuggestions = status === 'OK' ? predictions : [];
          this.isGoogleSuggestionsVisible = this.isAutoLocationSupported || this.placeSuggestions.length > 0;
        }
      );
    },

    fillPosition(position) {
      return new Promise((resolve) => {
        const latLng = new window.google.maps.LatLng(position.lat, position.lng);
        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({latLng: latLng}, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {
            this.textSearchQuery = this.nearLocation(get(results, '[0].formatted_address', ''));
            resolve();
          }
        });
      });
    },

    autoDetectLocation() {
      if (!this.isAutoLocationSupported || !this.isGoogleMapsReady || this.isAutoDetectingLocation) {
        return;
      }

      this.isAutoDetectingLocation = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.isAutoDetectingLocation = false;
          this.fillPosition({
            lng: position.coords.longitude,
            lat: position.coords.latitude,
          }).then(() => {
            this.$emit('location-auto-detected');
          });
          this.queryCenter = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        },
        () => {
          this.isAutoDetectingLocation = false;
          console.error('Failed to retrieve location.');
        }
      );
    },
  },
  data() {
    return {
      placeSuggestions: [],
      autoCompleteService: null,
      placesService: null,
      sessionToken: null,
      minQueryLength: 3,
      isAutoDetectingLocation: false,
      isGoogleMapsReady: false,
    };
  },
};

export {GoogleAutoComplete};
